module.exports = __webpack_public_path__ + "img/lady6.e81157b1.png";